"use strict";

let jsErrorHandling_ErrorArr;

function EncompassErrorHandler(message, fileURL, lineNum, columnNum, error) {
    if (message instanceof ErrorEvent) {
        fileURL = message.filename;
        lineNum = message.lineno;
        columnNum = message.colno;
        error = message.error;
        message = message.message;
    }
    message = EC_Fmt.Null2EmptyStr(message);
    // Task 697779: Javascript errors are not being logged to Support SystemErrors table
    if (!EC_Fmt.isNull(fileURL) && fileURL.toLowerCase().indexOf("jquery.js") === -1 && (fileURL.indexOf("aspx1/") !== -1 || fileURL.indexOf("GlobalDocs/") !== -1) && message.indexOf("nsIDOMWindowInternal.alert") === -1) {
        // Task 717744: Lots of 'Error in Promise' system errors - Find a way to pull out an inner error or better message even when the developer uses a try...catch inside of a JS Promise
        if (message.startsWith("Error in promise - ")) {
            message = message.slice(19);
        }

        let doNotReportError = false;

        if (fileURL.endsWith("UnknownFile") && EC_Fmt && typeof EC_Fmt.GetPageParameter === "function" && EC_Fmt.GetPageParameter("DashboardID")) {
            fileURL = `DashboardID=${EC_Fmt.GetPageParameter("DashboardID")}`;
        } else if (fileURL.endsWith("UnknownFile")) {
            doNotReportError = true;
        }

        // Don't report errors when running dashboard tests
        if (EC_Fmt && typeof EC_Fmt.GetPageParameter === "function" && EC_Fmt.GetPageParameter("RunCodeItemTest") === "True") {
            doNotReportError = true;
        }

        if (document.referrer.indexOf("OAuth") !== -1) {
            doNotReportError = true;
        }

        const KnownErrorsFromExtensions = [
            "removeNightMode is not defined",
            "extAbbr is not defined",
            "ResizeObserver loop limit exceeded",
            "NetworkError when attempting to fetch resource",
            "TypeError: Failed to fetch",
            "AbortError: The operation was aborted",
            "TypeError: The network connection was lost",
            "Object Not Found Matching Id",
            "TypeError: cancelled",
            "GetOAuthID. The remote server returned an error: (403) Forbidden.",
            "EC_Request: Failed to request",
            "The network connection was lost",
            "The request timed out",
            "Extension context invalidated",
            "TypeError: Load failed",
            "timeout",
            // EC-32717: the browser raises this when script on the page touches the third-party Statuspage embed iframe; naming that frame keeps every other same-origin-policy violation reportable
            "accessing a frame with origin \"https://61wj742cdkx7.statuspage.io"
        ];

        for (let i = 0; i < KnownErrorsFromExtensions.length; i++) {
            if (message.indexOf(KnownErrorsFromExtensions[i]) !== -1) {
                doNotReportError = true;
                break;
            }
        }

        const offlineCacheEnabled = typeof BC_EWS !== "undefined" && BC_EWS && BC_EWS.OfflineCacheEnabled;

        if (!window.navigator.onLine && !offlineCacheEnabled) {
            if (BC_EWS) {
                if (!BC_EWS.NoInternetDialog && !BC_EWS.NoInternetDialogInterval) {
                    clearInterval(BC_EWS.NoInternetDialogInterval);
                    BC_EWS.NoInternetDialog = ECP.Dialog.Alert("No Internet Connection");
                    BC_EWS.NoInternetDialogInterval = setInterval(() => {
                        if (navigator.onLine) {
                            // Task 713357: Javascript error: Failed to execute 'removeChild' on 'Node': parameter 1 is not of type 'Node'.
                            if (BC_EWS.NoInternetDialog && typeof BC_EWS.NoInternetDialog.remove === "function") {
                                BC_EWS.NoInternetDialog.remove();
                                BC_EWS.NoInternetDialog = undefined;
                            }
                            clearInterval(BC_EWS.NoInternetDialogInterval);
                        }
                    }, 1000);
                }
            } else {
                // eslint-disable-next-line no-alert
                alert("Internet Connection Lost");
            }
        } else if (window.navigator.onLine && !doNotReportError) {
            // Task 951060: Lots of duplicate system errors if the user makes a mistake in a code block
            if (!jsErrorHandling_ErrorArr) {
                jsErrorHandling_ErrorArr = [];
            }
            if (jsErrorHandling_ErrorArr.indexOf(message) === -1) {
                jsErrorHandling_ErrorArr.push(message);

                let CurDomain = "";

                try {
                    CurDomain = fileURL.split(/\/+/g)[1];
                } catch (e) {
                    // ignore this error
                }

                let stack = error ? error.stack : "Error details not received at EncompassErrorHandler()";
                if (fileURL.indexOf("aspx1/") !== -1) {
                    fileURL = fileURL.substring(fileURL.indexOf("aspx1/") + 6); // Remove the '/ECP.../aspx1/'
                }

                if (fileURL.indexOf(".js?v=") !== -1) {
                    const version = fileURL.substring(fileURL.indexOf(".js?v=") + 3);
                    fileURL = fileURL.replace(version, ""); // Remove the '?v=....' at the end
                    stack = EC_Fmt.ReplaceAll(stack, version, "");
                }

                stack = EC_Fmt.ReplaceAll(EC_Fmt.ReplaceAll(stack, `http://${CurDomain}/`, "/"), `https://${CurDomain}/`, "/");

                // Task 1064057: Use EC_ Request replace fetch
                const myRequest = new ECP.EC_Request("DevOps_JSErrorHandler");
                myRequest.SetReturnType(ECP.EC_ReturnType.Text);
                myRequest.AddRequestVariable("Error", message, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Domain", CurDomain, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("File", fileURL, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Line", lineNum, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Column", columnNum, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Stack", stack, ECP.EC_Verb.Post);
                myRequest.Submit().then(() => {
                    if (message.indexOf("<html><head><title>System Error</title>") === -1) {
                        // eslint-disable-next-line no-alert
                        alert(message);
                    } else {
                        // Task 657850: Find a way to get a better looking error when javascript receives HTML data from the server due to a System Error
                        const MainLayout = document.getElementById("MainLayout");

                        if (ECP?.Dialog && message.indexOf("</head><body") !== -1 && message.indexOf("</body>") !== -1) {
                            ECP.Dialog.ShowDialog("Error", message.substring(message.indexOf("</head><body") + 7, message.indexOf("</body>")), {
                                width: 600,
                                height: 300,
                                confirmButtonTitle: EC_Fmt.Trn("Continue")
                            });
                        } else if (MainLayout) {
                            MainLayout.innerHTML = message.substring(message.indexOf("<html><head><title>System Error</title>") + 39, message.indexOf("</body></html>"));
                        } else {
                            const errorDocument = new DOMParser().parseFromString(message.substring(message.indexOf("<html><head><title>System Error</title>")), "text/html");
                            document.documentElement.replaceWith(document.importNode(errorDocument.documentElement, true));
                        }
                        if (ECP?.Dialog) {
                            setInterval(() => {
                                ECP.Dialog.HideLoading();
                            }, 1000);
                        }
                    }
                }).catch((postError) => {
                    // eslint-disable-next-line no-alert
                    alert(postError);
                });

                // Task 1033298: Adding Google Analytics as a default feature of dashboards
                if (gtag) {
                    gtag("event", "exception", { description: message, fatal: false });
                }
            }
        }
    }
}

window.addEventListener("error", EncompassErrorHandler);

window.addEventListener("unhandledrejection", (event) => {
    EncompassErrorHandler(event.reason, "aspx1/UnknownFile", 0, 0, event.reason);
});
